import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class EditRunbookService {
  private runBookData: any;
  private isEdit: any;
  private instancedata: any;

  setData(data: any) {
    this.runBookData = data;
  }

  getData(): any {
    return this.runBookData;
  }

  getIsEdit(): any {
    return this.isEdit;
  }

  setIsEdit(data: any){
    this.isEdit = data;
  }
  clearData() {
    this.runBookData = null;
    this.isEdit = false;
  }

  setInstance(data:any){
    this.instancedata = data;
  }

  getInstance(){
    return this.instancedata;
  }
}